import throttle from '@plugins/throttle';
import AauwModals from '@components/modal/aauw-modals';
import CookieNotice from '@components/cookie-notice';
import PersistentSignUp from '@components/persistent-sign-up';

/**
 * Centralized manager for all popup functionality that is not directly
 * triggered by the user. Meant to help avoid overwhelming visitors with popup
 * hell.
 */
export default class AauwPopupManagement {

  constructor() {
    // Track whether we have yet to show any popups at all
    this.hasPopped = false;

    // Track the last time the user scrolled
    this.lastScroll = null;

    // Initialize in order of priority
    this.popupObjects = [
      new CookieNotice(),
      new AauwModals(),
      // Always put Persistent Sign Up last, as it is, well, persistent.
      // So long as the user doesn't X it away, it would block any pop-ups later
      // in order by always returning true from its callback.
      new PersistentSignUp()
    ];

    $(document).on('aauw-popup-closed', () => {
      // Try to pop something else up after 10 seconds
      setTimeout(() => {
        this.nextPopup();
      }, 10000);
    });

    $(window).on('scroll', throttle(
      () => {
        this.logScroll();
      }, 250)
    );

    this.nextPopup(true);
  }

  logScroll() {
    this.lastScroll = Date.now();
  }

  /**
   * Traverse the ring of different popup functionality to find one and only one
   * to display.
   */
  nextPopup(ignoreScrollingRules) {
    // Normally we require the user to have scrolled at least once, and to not
    // have scrolled recently, before showing the next popup.
    // If something passes a true value (the constructor) we don't check for
    // this.
    if (!ignoreScrollingRules) {
      if (!this.lastScroll || this.lastScroll > (Date.now() - 5000)) {
        setTimeout(() => {
          this.nextPopup();
        }, 1000);

        return false;
      }
    }

    let popupTriggered = false;
    let nextPopupTypeIndex = 0;

    while (!popupTriggered && nextPopupTypeIndex < this.popupObjects.length) {
      if (typeof this.popupObjects[nextPopupTypeIndex].popupManagementCall !== 'function') {
        throw 'No popup management function to call on ' + this.popupObjects[nextPopupTypeIndex].constructor.name;
      }

      popupTriggered = this.popupObjects[nextPopupTypeIndex].popupManagementCall(this.hasPopped);

      nextPopupTypeIndex += 1;
    }

    if (popupTriggered) {
      this.hasPopped = true;
    }

    return popupTriggered;
  }

}
